<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">Email</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                v-model="email"
                name="search"
                class="form-control input"
                maxLength="30"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button
                class="btn btn btn-primary"
                :disabled="!email"
                @click="search"
              >
                {{ $t("message.Search") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <el-table
                :data="rows"
                sort
                style="width: 100%"
                border
                ref="multipleTable"
              >
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column
                  prop="email"
                  label="Email"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="deleteStatus"
                  label="Is Deleted"
                  width="120"
                >
                  <template slot-scope="scope">
                    {{scope.row.deleteStatus?'Yes':'No'}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="deleteTime"
                  label="Delete Time"
                  width="170"
                >
                  <template slot-scope="scope">
                    <div class="wrap2">
                      {{scope.row.deleteTime}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="cancelTime"
                  label="Cancel Time"
                  width="170"
                >
                  <template slot-scope="scope">
                    <div class="wrap2">
                      {{scope.row.cancelTime}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="cancelCount"
                  label="Cancel Count"
                  width="170"
                ></el-table-column>
                <el-table-column
                  prop="cancelBy"
                  label="Cancel By"
                  width="170"
                >
                  <template slot-scope="scope">
                    <div class="wrap2">
                      {{scope.row.cancelBy}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Action" fixed="right">
                  <template slot-scope="scope">
                    <el-popconfirm
                        title="Are you sure you want to cancel?"
                        confirmButtonText="Yes"
                        v-if="scope.row.canCancel"
                        cancelButtonText="No"
                        @confirm="cancelAccountDeletion(scope.row.email)"
                      >
                      <el-button 
                        size="mini" 
                        type="primary" 
                        slot="reference"
                        >Cancel
                      </el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      email: "",
      rows: [],
    };
  },
  created: function () {},
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.email = this.email;
      objdata.apiUrl = "/findAccountDeletion";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      // let list = null;
      // for (list of data.data.resultList) {
      //   if (list.status == 1) {
      //     list.status = "Active";
      //   } else {
      //     list.status = "Inactive";
      //   }
      // }
      this.rows = [];
      if(data.data.result){
        this.rows.push(data.data.result);
      }
      
    },
    async search() {
      this.init();
    },
    async cancelAccountDeletion() {
      let objdata = this.getAuthObj();
      objdata.email = this.email;

      objdata.apiUrl = "/cancelAccountDeletion";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$message({
          message: "Cancel Successfully",
          type: "success"
        });
        this.init();
      }
    },
  },
  mounted() {},
};
</script>
